export default "__VITE_ASSET__BQfuC16Q__"